/* global analytics */
import React, { Component } from "react";
import "./assets/css/sharedBoxHeaderStyle.css";
import dropShadow from "./assets/img/box-dropshadow.png";
import env from "../../utils/env";

export default class SharedBoxHeader extends Component {

    getBoxTotal = (sysdata) => {
        let { boxItems, isProspect } = sysdata.boxData;
        if (isProspect || boxItems == null) {
            return "200+";
        }
        let total = 0;
        boxItems.forEach(item => {
            total = total + item.retailPrice;
        })
        total = Math.ceil((Math.round(total)) / 10) * 10 - 10;
        return total;
    }

    getBoxSubTitle = (sysdata) => {
        if (sysdata.isProspect) {
            return `That's a Total value ~ 200+ for just $49.99`;
        } else {
            return `See what’s inside my ${this.getBoxName(sysdata.boxData.currentBox.name)}.`;
        }
    }

    getBoxName = (boxName) => {
        const boxNameArray = boxName.split(" ");
        if (boxNameArray[boxNameArray.length - 1].toLowerCase() !== "box") {
            return boxName + " Box";
        }
        return boxName;
    }

    handleClick = () => {
        window.location.href = "/get-the-box/?step=getbox";
        analytics.track('Clicked Element', {
            element_name: 'Get the Box',
            option_title: 'Page header'
          });
    }
    
    render(){
        const { sysdata } = this.props;
        if (sysdata && !sysdata.boxData.currentBox) {
            window.location.href = "/";
        }
        const { boxData, isMobile, isProspect } = sysdata;
        const avatar = sysdata.avatarUrl.userAvatarUrl;
        const firstName = sysdata.firstName.firstName;
        const boxImageUrl = boxData.currentBox && boxData.currentBox.imageUrl ? boxData.currentBox.imageUrl : null;
        const dropShadowUrl = `${env.cfURL}${dropShadow}`;
        window.dropShadowUrl = {cfUrl:env.cfURL, dropShadow}
        return (
            <header className={"sbh " + (isProspect ? "sbh__prospect " : "") + (isMobile ? "sizeSmall" : "sizeLarge")}>
                <div className={isMobile ? "sbh__wave-cont sbh__wave-cont--no-wave" : "sbh__wave-cont"}></div>
                <div className="sbh__cont">
                    <div className="sbh__text-cont">
                        <p className="sbh__name">{firstName}'s</p>
                        <p className="sbh__box-season">{this.getBoxName(boxData.currentBox.name)}</p>
                        <p className="sbh__box-total">{this.getBoxSubTitle(sysdata)}</p>
                        {isProspect && !isMobile && (
                            <React.Fragment>
                                <button className="sbh__gtb shared-button shared-button-cta" onClick={this.handleClick}>GET THE BOX</button>
                                <p className="sbh__gtb-text">Customize Your Own FabFitFun Box Today</p>
                            </React.Fragment>
                        )}
                    </div>
                    <div className="sbh__box-img-cont">
                        <div className="sbh__img-cont">
                            <img alt="fabfitfun box" className="sbh__box-image" src={boxImageUrl}/>
                            <img alt="" className="shb__box-shadow" src={dropShadowUrl} />
                            <img alt="member avatar" className="sbh__avatar" src={avatar}/>
                        </div>
                    </div>
                    {isProspect && isMobile && (
                        <React.Fragment>
                            <button className="sbh__gtb shared-button shared-button-cta" onClick={this.handleClick}>GET THE BOX</button>
                            <p className="sbh__gtb-text">Customize Your Own FabFitFun Box Today</p>
                        </React.Fragment>
                    )}
                </div>
            </header>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/SharedBoxHeader/SharedBoxHeader.js